import React, { useState, useEffect, useMemo } from "react";
import Box from "@mui/system/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import "./styles/Home.css";
import { ClinicalDashboard } from "./../components/scripts/ClinicalDashboard";
import { ClinicalQueueContent } from "./../components/scripts/ClinicalQueueContent";
import { ApiCall } from "./../utility/ApiCalls";
import axios from "axios";
import Loader from "react-loader-spinner";
import requests from "../utility/Requests";
import { useLocation } from "react-router-dom";
import Api_Call from "../ApiCall";
import info from "./../info.json";
function ClinicalHome() {
  const [activeTaskData, setActiveTaskData] = useState([]);
  const [taskData, setTaskData] = useState([]);
  const [displayReadyAssignedTable, setDisplayReadyAssignedTable] =
    useState(false);
  const [displayReadyActiveTable, setDisplayReadyActiveTable] = useState(false);
  const [displayReadyDashboard, setDisplayReadyDashboard] = useState(false);
  const [dashboardData, setDashboardData] = useState({});

  const [dashboardTasklist, setDashboardTasklist] = useState();
  const [taskQueue, setTaskQueue] = useState([]);

  const [isLoading, setLoading] = useState(false);
  const [taskBtn, setTaskBtn] = useState(true);
  const [completedListFlag, setCompletedListFlag] = useState(true);
  const [auditedData, setAuditedData] = useState("");

  const location = useLocation();
  const selectedTile = new URLSearchParams(location.search).get("selectedTile");
  console.log(selectedTile);

  const [activeStyle, setActiveStyle] = useState({
    pending: false,
    inprogress: false,
    completed: false,
    audited: false,
    mdresponse: false,
  });

  console.log(dashboardTasklist);
  useEffect(async () => {
    taskQueueApi();
  }, []);
  // API CALL FUNCTION DECLARATION  ============================================================
  async function getTaskfromAPI() {
    // const retAssigned = await ApiCall(
    //   {
    //     requestType: "Agent",
    //     filterType: "",
    //     status: "T01",
    //     agentID: sessionStorage.getItem("UserID"),
    //     supervisorID: "",
    //   },
    //   "vcare-ui",
    //   "tasklist"
    // );
    // const response1 = retAssigned.body;
    // setTaskData(response1);
    // if (retAssigned.statusCode == "200") {
    //   setDisplayReadyAssignedTable(true);
    // }
  }
  async function getActiveTaskfromAPI() {
    // const retActive = await ApiCall(
    //   {
    //     requestType: "Agent",
    //     filterType: "",
    //     status: "T02",
    //     agentID: sessionStorage.getItem("UserID"), //GET ID from SESSION
    //     supervisorID: "",
    //   },
    //   "vcare-ui",
    //   "tasklist"
    // );
    // const response2 = retActive.body;
    // setActiveTaskData(response2);
    // if (retActive.statusCode == "200") {
    //   setDisplayReadyActiveTable(true);
    // }
  }
  async function getDashboardCountfromAPI() {
    const ret = await ApiCall(
      {
        DigitalProcess: "Intake",
        UserId: sessionStorage.getItem("UserID"),
        // UserId: sessionStorage.getItem("user_id"),
        shiftStart: "2021-11-09", //TODO: Set to Session Shift Start
        UserRole: sessionStorage.getItem("Role"),
      },
      "vcare-ui",
      "dashboardcount"
    );

    const response = ret.body;
    setDashboardData(response[0]);

    if (ret.statusCode == "200") {
      setDisplayReadyDashboard(true);
    }
  }

  useEffect(() => {
    // getTaskfromAPI();
    // getActiveTaskfromAPI();
    // getDashboardCountfromAPI();
    // dashboardApi();
    // taskQueueApi();
  }, []);

  let dashboard_tasklist_url = requests.dashboard_tasklist_url;

  const dashboardApi = () => {
    axios
      .post(dashboard_tasklist_url, {
        StatusCode: "",
        ReturnType: "Totals",
        clinical_status: "1",
      })
      .then((res) => {
        setDashboardTasklist(res.data.body);
      });
  };

  const taskQueueApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: true,
      inprogress: false,
      completed: false,
      audited: false,
      mdresponse: false,
    });
    setLoading(true);
    setTaskBtn(true);
    setCompletedListFlag(false);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `TASK-LIST?status=5&module=clinicalreview`
      );
      setTaskQueue(data.body[0]["Pending"]);
      setDashboardTasklist(data.body[0]["CountOfCases"]);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    // axios
    //   .post(dashboard_tasklist_url, {
    //     StatusCode: "5",
    //     ReturnType: "List",
    //     clinical_status: "1",
    //   })
    //   .then((res) => {
    //     setTaskQueue(res.data.body);
    //     setLoading(false);
    //     dashboardApi();
    //   });
  };

  const taskQueueInprogressApi = async () => {
    console.log("--------------InProgress Api Called------------");
    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: true,
      completed: false,
      audited: false,
      mdresponse: false,
    });
    setLoading(true);
    setTaskBtn(false);
    setCompletedListFlag(false);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `TASK-LIST?status=6&module=clinicalreview`
      );
      setTaskQueue(data.body[0]["InProgress"]);
      setDashboardTasklist(data.body[0]["CountOfCases"]);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    console.log("Count of cases----->", dashboardTasklist);
    // axios
    //   .post(dashboard_tasklist_url, {
    //     StatusCode: "6",
    //     ReturnType: "List",
    //     clinical_status: "1",
    //   })
    //   .then((res) => {
    //     setTaskQueue(res.data.body);
    //     setLoading(false);
    //     dashboardApi();
    //   });
  };

  const taskQueueCompletedApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: false,
      completed: true,
      audited: false,
      mdresponse: false,
    });
    setLoading(true);
    setTaskBtn(false);
    setCompletedListFlag(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `TASK-LIST?status=7&module=clinicalreview`
      );
      setTaskQueue(data.body[0]["Completed"]);
      setDashboardTasklist(data.body[0]["CountOfCases"]);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }

    // axios
    //   .post(dashboard_tasklist_url, {
    //     StatusCode: "7",
    //     ReturnType: "List",
    //     clinical_status: "1",
    //   })
    //   .then((res) => {
    //     setTaskQueue(res.data.body);
    //     setLoading(false);
    //     dashboardApi();
    //   });
  };

  const taskQueueAuditedApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: false,
      completed: false,
      audited: true,
      mdresponse: false,
    });
    setLoading(true);
    setTaskBtn(false);
    setCompletedListFlag(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `TASK-LIST?status=12&module=clinicalreview`
      );
      setTaskQueue(data.body[0]["AuditCompleted"]);
      setAuditedData(data.body[0]["AuditCompleted"]);
      setDashboardTasklist(data.body[0]["CountOfCases"]);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    // axios
    //   .post(dashboard_tasklist_url, {
    //     StatusCode: 12,
    //     ReturnType: "List",
    //     clinical_status: "1",
    //   })
    //   .then((res) => {
    //     setTaskQueue(res.data.body);
    //     setAuditedData(res.data.body);
    //     setLoading(false);
    //     dashboardApi();
    //   });
  };

  const taskQueueMdResponseApi = async () => {
    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: false,
      completed: false,
      audited: false,
      mdresponse: true,
    });
  };

  const memoizedAuditedData = useMemo(() => auditedData, [auditedData]);
  useEffect(() => {
    if (selectedTile == "Audited") taskQueueAuditedApi();
  }, [selectedTile]);

  // if (
  //   displayReadyAssignedTable &&
  //   displayReadyActiveTable &&
  //   displayReadyDashboard
  // ) {
  return (
    <>
      <Box className="primary-title-new">
        <img src="img/heading-bg.png" />
        <Typography variant="h1">
          Utilization Management - Clinical Review
        </Typography>
      </Box>
      <ClinicalDashboard
        type="agent"
        dashboardTasklist={dashboardTasklist}
        handlePending={taskQueueApi}
        handleInprogress={taskQueueInprogressApi}
        handleCompleted={taskQueueCompletedApi}
        handleAudited={taskQueueAuditedApi}
        handleMdResponse={taskQueueMdResponseApi}
        activeStyle={activeStyle}
      ></ClinicalDashboard>
      {isLoading ? (
        <>
          <div className="content-container">
            <div className="div-loading">
              <Loader type="Puff" color="#00BFFF" height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <ClinicalQueueContent
          type="agent"
          taskQueueData={taskQueue}
          taskBtn={taskBtn}
          completedListFlag={completedListFlag}
          activeStyle={activeStyle}
          taskQueueInprogressApi={taskQueueInprogressApi}
        ></ClinicalQueueContent>
      )}
    </>
  );
  // } else {
  //   return <></>;
  // }
}

export default ClinicalHome;
